
export const setPagCount = (pagCount) => (
    {
      type:'SET_PAG_COUNT',
      pagCount,
    }
  );

export const setMaxCount = (maxCount) => (
  {
    type:'SET_MAX_COUNT',
    maxCount,
  }
);

export const setTheFilteredListing = (maxCount) => (
  {
    type:'SET_THE_FILTERED_LISTING',
    theFilteredListing,
  }
);